// A task has one notion of "where is it": the stage it stands on in the timeline
// of its service type (/settings/timelines). The backend resolves it into
// task.resolved_stage = { stage_id, name, color, stage_index, stage_count,
// is_last, template_name, is_default }. There is no task status behind it.
//
// USAGE:
//   import { taskStage, isTaskDone, stageBadgeStyle } from "../lib/taskStage";

const FALLBACK_COLOR = "#71717a";

export function taskStage(task) {
  return task?.resolved_stage || null;
}

// The last stage of a timeline means the task is done.
export function isTaskDone(task) {
  return Boolean(task?.resolved_stage?.is_last);
}

// Stage name, for filters and sorting across tasks of different services.
export function taskStageName(task) {
  return task?.resolved_stage?.name || "";
}

function _isHex(c) {
  return typeof c === "string" && /^#[0-9a-f]{3,8}$/i.test(c);
}

export function stageColor(color) {
  return _isHex(color) ? color : FALLBACK_COLOR;
}

export function stageBadgeStyle(color) {
  const c = stageColor(color);
  return {
    backgroundColor: `${c}33`, // ~20% alpha
    borderColor: `${c}80`,     // ~50% alpha
    color: c,
  };
}

export function stageBarStyle(color) {
  const c = stageColor(color);
  return {
    backgroundColor: `${c}66`, // ~40% alpha
    borderColor: `${c}b3`,     // ~70% alpha
    color: "#ffffff",
  };
}
